module.exports = __webpack_public_path__ + "static/media/Retrusion of the anterior teeth4.619be798.png";